<template>
  <div>
    <div class="hideTotal" v-if="operate === 'list'">
      <table-search label-width="65px" @search="fetchList(1)" @reset="handleReset">
        <template v-slot:basic>
          <el-form-item label="委托单号">
            <el-input v-model="query.id" placeholder="请输入委托单号"/>
          </el-form-item>
          <el-form-item label="报价方向">
            <el-select v-model="query.billType" placeholder="请选择报价方向">
              <el-option v-for="(item, index) in $key.transation.billType" :key="index" :label="item.name" :value="item.id"/>
            </el-select>
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="query.entrustStatus" placeholder="请选择状态">
              <el-option v-for="(item, index) in $key.transation.entrustStatus" :key="index" :label="item.name" :value="item.id"/>
            </el-select>
          </el-form-item>
          <el-form-item label="委托日期" class="single-date">
            <el-date-picker v-model="query.entrustDay" value-format="yyyy-MM-dd" type="date" clearable placeholder="请选择日期"/>
          </el-form-item>
        </template>
      </table-search>
      <inquery-result :isExport="false"></inquery-result>
      <el-table :data="tableData">
        <el-table-column label="委托单号" prop="id" align="center"/>
        <el-table-column label="商品名称" prop="productName" align="center"/>
        <el-table-column label="仓库" prop="whName" align="center"/>
        <el-table-column label="交货日期" prop="deliveryDate" align="center"/>
        <el-table-column label="报价方向" prop="billType" align="center">
          <template slot-scope="scope">
            {{ scope.row.billType | keyFilter('transation', 'billType') }}
          </template>
        </el-table-column>
        <el-table-column label="委托单价" prop="price" align="center">
          <template slot-scope="scope">
            {{ scope.row.price | thousandMark }}
          </template>
        </el-table-column>
        <el-table-column label="委托数量" prop="qty" align="center"/>
        <el-table-column label="成交数量" prop="transactionQty" align="center"/>
        <el-table-column label="剩余数量" prop="residueQty" align="center"/>
        <el-table-column label="状态" prop="entrustStatus" align="center">
          <template slot-scope="scope">
            {{ scope.row.entrustStatus | keyFilter('transation', 'entrustStatus') }}
          </template>
        </el-table-column>
        <el-table-column label="委托时间" prop="entrustDate" align="center"/>
        <el-table-column label="操作" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button v-action:detail type="text" @click="detail(scope.row)">详情</el-button>
            <el-button :loading="loading" v-if="canCancel(scope.row)" v-action:cancel type="text" @click="cancel(scope.row)">撤销</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination class="pagination" layout="total, prev, pager, next" :current-page.sync="currentNo" :total="total" background @current-change="fetchList"/>
    </div>
    <detail v-if="operate === 'detail'" :row="row" @close="close"/>
  </div>
</template>

<script>
import detail from './detail'
import API from '@/api'
function Query () {
  return {
    id: '', // 单号
    billType: null, // 方向
    entrustStatus: null, // 状态
    entrustDay: '', // 日期
  }
}
export default {
  name: 'entrustRecord',
  components: {
    detail
  },
  data () {
    return {
      query: new Query(),
      currentNo: 1,
      total: 0,
      tableData: [], // 表格数据
      operate: 'list',
      row: {},
      loading: false,
    }
  },
  mounted () {
    this.fetchList(1)
  },
  methods: {
    fetchList (currentNo) {
      this.currentNo = currentNo || this.currentNo || 1
      let param = {
        ...this.query,
        pageNumber: this.currentNo,
        pageSize: 10
      }
      API.transationManage.entrustList(param).then(res => {
        this.tableData = res.data.rows
        this.total = res.data.totalElements
      })
    },
    // 撤销
    cancel (row) {
      this.$confirm('请确认是否撤回委托单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const param = {
          ...row,
          entrustId: row.id,
        }
        this.loading = true
        API.transationManage.entrustCancel(param).then(res => {
          this.$message.success('撤销成功')
          this.fetchList(this.currentNo)
          this.loading = false
        }).catch(er => {
          this.loading = false
        })
      })
    },
    detail (row) {
      this.row = row
      this.operate = 'detail'
    },
    // 重置搜索
    handleReset () {
      this.query = new Query()
      this.fetchList(1)
    },
    // 判断是否有撤销按钮
    canCancel (row) {
      if (row.entrustStatus !== 'PART_CANCEL' && row.entrustStatus !== 'CANCEL' && row.entrustStatus !== 'OK') {
        return true
      } else {
        return false
      }
    },
    close () {
      this.operate = 'list'
      this.fetchList(this.currentNo)
    }
  }
}
</script>
